module.exports = __webpack_public_path__ + "img/conjunctival-hyperemia-3.449602b1.jpg";